export const DECREASE_CART_COUNT= 'DECREASE_CART_COUNT'
export const DECREASE_CART_COUNT_SUCCESS= 'DECREASE_CART_COUNT_SUCCESS'
export const DECREASE_CART_COUNT_ERROR='DECREASE_CART_COUNT_ERROR'

export const DecreaseCartCount= (data) => ({
    type: DECREASE_CART_COUNT,
    payload: data
})